<script>
import Topbar from '@components/topbar'
import AppMenu from '@components/appMenu'

/** Match $sidebar-overlay-max in scss/_variables.scss */
const SIDEBAR_DRAWER_MAX = 991

export default {
  components: { Topbar, AppMenu },
  data() {
    return {
      showMobileMenu: false,
      /** Match $topbar-height in scss/_variables.scss */
      topbarHeightPx: 72,
    }
  },
  created: () => {
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
    document.body.setAttribute('data-layout', 'topnav')
    document.body.classList.remove('right-bar-enabled')
    document.body.classList.remove('left-side-menu-condensed')
    document.body.classList.remove('boxed-layout')
  },
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    closeMobileMenu() {
      this.showMobileMenu = false
    },
    onResize() {
      if (window.innerWidth > SIDEBAR_DRAWER_MAX) {
        this.showMobileMenu = false
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    $route() {
      this.showMobileMenu = false
    },
  },
}
</script>

<template>
  <div class="topnav topnav-horizontal-root">
    <aside
      class="topnav-horizontal-sidebar"
      :class="{ 'topnav-horizontal-sidebar--open': showMobileMenu }"
    >
      <AppMenu mode="horizontal" class="" />
    </aside>

    <button
      v-if="showMobileMenu"
      type="button"
      class="topnav-horizontal-backdrop"
      aria-label="Close menu"
      @click="closeMobileMenu"
    />

    <div class="topnav-horizontal-main content-page w-100 bg-light">
      <Topbar
        :user="user"
        :is-menu-opened="showMobileMenu"
        class="bg-white"
      />
      <div
        class="topnav-horizontal-scroll pt-5"
        :style="{
          overflowY: 'scroll',
          height: `calc(100vh - ${topbarHeightPx}px)`,
          backgroundColor: '#f5f8fa',
        }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
// Keep in sync with src/scss/_variables.scss ($leftbar-width, $sidebar-overlay-max, $topbar-height)
$horizontal-leftbar-width: 240px;
$horizontal-overlay-max: 991px;
$horizontal-topbar-height: 72px;

.topnav-horizontal-root {
  display: flex;
  min-height: 100vh;
  width: 100%;
  position: relative;
}

.topnav-horizontal-sidebar {
  flex-shrink: 0;
  width: $horizontal-leftbar-width;
  min-height: 100vh;
  background-color: #1e1e2d;
  box-shadow: 2px 4px 60px 0 rgba(0, 0, 0, 0.15);
  z-index: 1;
}

.topnav-horizontal-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.topnav-horizontal-backdrop {
  display: none;
}

@media (max-width: $horizontal-overlay-max) {
  .topnav-horizontal-root {
    display: block;
  }

  .topnav-horizontal-sidebar {
    position: fixed;
    top: $horizontal-topbar-height;
    left: 0;
    bottom: 0;
    width: min(#{$horizontal-leftbar-width}, 92vw);
    min-height: 0;
    z-index: 1100;
    transform: translateX(-100%);
    transition: transform 0.2s ease-in-out;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .topnav-horizontal-sidebar--open {
    transform: translateX(0);
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  }

  .topnav-horizontal-backdrop {
    display: block;
    position: fixed;
    top: $horizontal-topbar-height;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1090;
    padding: 0;
    margin: 0;
    border: none;
    background: rgba(0, 0, 0, 0.35);
    cursor: pointer;
  }
}
</style>
